import { CustomColorSupport, StepHandle } from "..";
import { shapeStepService } from "../../services/steps/shape";
import { ColorOption, ShapeStepData, Step } from "../../types";
import { WorkflowManager } from "../../WorkflowManager";
import { Variant } from "../resource/variant";

export class ShapeStepHandle extends StepHandle<ShapeStepData> implements CustomColorSupport {
    constructor(manager: WorkflowManager, step: Step<ShapeStepData>, tags: string[]) {
        super(manager, step, tags);
    }

    selectVariant(variant: Variant) {
        const colorVariant = variant.getResource();
        return shapeStepService.selectVariant(
            this.step,
            {
                fill: colorVariant.color,
                stroke: colorVariant.color,
                variant: colorVariant,
            },
            this.manager.getRegionElements(this.step.stepName) || [],
            this.manager,
        );
    }

    /**
     * Sets the color of the shape.
     * @param color The color option to use.
     * @returns A promise resolving when the color has changed in the design.
     * @deprecated The shape step can now pass through colors returned by getColors via selectVariant. Please swap setColor for selectVariant.
     */
    setColor(color: ColorOption) {
        return shapeStepService.selectVariant(
            this.step,
            color,
            this.manager.getRegionElements(this.step.stepName) || [],
            this.manager,
        );
    }

    /**
     * Get available colors for the shape.
     * @returns A list of color definitions that are currently applied to the illustration.
     */
    getColors() {
        return shapeStepService.availableColours(this.step);
    }

    /**
     * Allows for setting a custom color when the custom variant is selected. Will
     * throw when a non-custom variant is selected.
     */
    setCustomColor(color: string) {
        if (this.getCurrentVariant()?.getColor() !== "#custom") {
            console.warn(`setting custom color for step ${this.step.stepName} but color is ${this.getCurrentVariant()?.getColor()}`);
        }
        return shapeStepService.setCustomColor(color, this.step, this.manager);
    }

    getCustomColor(): string {
        if (this.getCurrentVariant()?.getColor() !== "#custom") {
            console.warn(`setting custom color for step ${this.step.stepName} but color is ${this.getCurrentVariant()?.getColor()}`);
        }
        const color = this.manager.getStepStorage(this.step.stepName)?.colour;
        if (!color) throw new Error(`Color not available on step ${this.step.stepName}. Set a default on the workflow to fix this.`);
        return color;
    }
}
